// extracted by mini-css-extract-plugin
module.exports = {"downloadCSV":"styles_downloadCSV__Stk02"};